import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import {validateFields}  from '../helpers/validateFields';

const useStyles = makeStyles(theme => ({
    dense: {
        marginTop: theme.spacing(2),
        backgroundColor: 'white',

    },
    checkbox: {
        marginTop: theme.spacing(2),
    }
}));

const CheckBoxes = (props) => {
    const classes = useStyles();

    const [purchaseRequired, setPurchaseRequired] = useState(false);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
                <h2>Check the boxes below:<label style={{ fontSize: '12px', color: '#767676', fontWeight: 'lighter' }}> * Optional</label></h2>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.checkbox}>
                <Checkbox value={false} id="fuelCutOfDevice" /> Does any vehicle need to be equiped with a fuel cut off device?                
            </Grid>
            <Grid item xs={12} sm={6} className={classes.checkbox}>
                <Checkbox value={false} id="bikeTruckOrMachinery" /> Will any trackers be installed on a bike truck or machinery
            </Grid>
            <Grid item xs={12} sm={12} className={classes.checkbox}>
                <Checkbox value={false} id="identifyFleetDrivers" /> Will you need to identify the fleet drivers?
            </Grid>
            <Grid item xs={12} sm={12}>
                {(purchaseRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right' }}>* Required</label> : <label></label>}
                <TextField id="howManyTracker"
                    label="How many trackers would you like to purchase?"
                    className={classes.dense}
                    margin="dense"
                    error={purchaseRequired}
                    style={{ marginTop: purchaseRequired ? '3px' : '23px', }}
                    variant="outlined"
                    fullWidth={true}
                    onInput={async(e) => {
                        const patternOnlyNumber = /\d+/g;
                        if (String(e.target.value) !== "") {
                            var newValue = (String(e.target.value).match(patternOnlyNumber) !== null) ? String(e.target.value).match(patternOnlyNumber)[0] : '';
                            e.target.value = Number(newValue);
                        } else {
                            e.target.value = '';
                        }
                        e.target.value = (e.target.value !== '') ? Math.max(0, parseInt(e.target.value)).toString().slice(0, 3) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (String(e.target.value.length) > 0) ? setPurchaseRequired(false) : setPurchaseRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    value={props.howManyTracker} />
            </Grid>
        </Grid>
    )
};

export default CheckBoxes;